import * as React from 'react';
import styles from './LayoutCentral.module.scss';

export function LayoutCentral(props: { children?: React.ReactNode }) {
    return (
        <div className={styles.layoutContainer}>
            {props.children}
        </div>
    )
}
